var _g, _ellipse, _g2, _path, _path2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 98,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#eaeef4"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 9a1 1 0 0 1 1-1h46a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.333,
    y: 15.333,
    width: 36,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 46.875c0-.483.392-.875.875-.875h46.25c.483 0 .875.392.875.875s-.392.875-.875.875h-46.25c-.483 0-.875-.392-.875-.875zm-5 5.25c0-.483.392-.875.875-.875h28.25c.483 0 .875.392.875.875s-.392.875-.875.875h-28.25c-.483 0-.875-.392-.875-.875z",
    fillRule: "evenodd"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79,
    cy: 88.5,
    rx: 60,
    ry: 9.5,
    fill: "#f5f8fa"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#eaeef4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 17,
    r: 17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 31.5,
    r: 11.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 17h46a4 4 0 0 1 4 4v58a4 4 0 0 1-4 4H61V17z",
    fill: "#00baff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 21a4 4 0 0 1 4-4h9v66h-9a4 4 0 0 1-4-4V21z",
    fill: "url(#A)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 56a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v27H76V56z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M91.848 29.54c.164.067.605.25.98.459.631.407 1.396 1.782 1.396 1.782s.478.678.471.765c-.023.249-.137.468-.225.636-.108.206-.445.848-.721 1.034-.284.192-1.404.724-2.299 1-.245.085-.726.291-1.002.618l-3.683 3.977-.519-.16s.87-1.082.608-2.446c-.21-1.092-.77-1.716-.77-1.716s.897 1.434.184 3.043a3.61 3.61 0 0 1-.837 1.133c-.068.057-.124.096-.164.124-.087.061-.102.071-.008.102l.293.093 1.405.447c.819.253 1.015.93.988 1.204-.01.108-.064.364-.064.364l-3.492-1.142-2.479-.794c-.205-.02-.557-.286-.563-.584v-.194c.001-.235.003-.497-.057-.612-.035-.05-.128-.154-.258-.299-.323-.359-.873-.971-1.321-1.649-.569-.861-.808-1.79-.669-2.785.245-1.752 2.241-3.167 3.813-2.879l1.112.244 5.04 1.052c-.064-.709.159-1.347.499-1.896-.133-.184-.7-.659-1.789-.441-.963.193-1.744.163-2.221.133-.662-.042-2.596-.733-3.532-1.068l-.493-.172c-.431-.129-.143-.377.164-.515.135-.061.358-.16.72-.276.88.437 1.927.9 2.904 1.209.498.157 1.355.233 2.419.163 1.106-.072 1.936.191 2.154.52-.12-.201-.712-.753-1.929-.726a9.06 9.06 0 0 1-2.408-.28c-.53-.129-1.748-.836-2.716-1.424l-.714-.437-.623-.375c-.383-.191-.149-.296.2-.386l.116-.031c.369-.1 1.17-.317 2.388-.354 1.478-.044 2.938.646 3.942 1.121l.471.219c.98.438 3.201 2.126 3.201 2.126l.093.072zm-8.763 12.159a.37.37 0 0 1-.022-.638c.14-.07.275-.01.275-.01l.864.29s-.861.502-1.118.358z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 41.5,
    y1: 50,
    x2: 66.529,
    y2: 54.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007cff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessState);
export default __webpack_public_path__ + "static/media/success-state.7e0060fc.svg";
export { ForwardRef as ReactComponent };